// extracted by mini-css-extract-plugin
export var bounce = "styles-module--bounce--645c9";
export var icon = "styles-module--icon--74527";
export var item = "styles-module--item--65eac";
export var item_text = "styles-module--item_text--5aa94";
export var items = "styles-module--items--83a8a";
export var pulse = "styles-module--pulse--ff8e5";
export var section = "styles-module--section--59650";